<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="modal-title-exit-btn">
        <h2 class="modal-title">What is Organization type?</h2>
        <v-btn icon @click="() => $emit('closeModal')">
          <v-icon color="#979797">clear</v-icon>
        </v-btn>
      </div>

      <p class="description">There are three types of organization that you can create:</p>
      <ul>
        <li class="description">
          <strong>Regular:</strong> Suited for general events. Manage event listings, handle online
          ticket sales, and work with external ticket sellers.
        </li>
        <li class="description">
          <strong>Theater:</strong> Specifically for theater performances. Manage multiple shows,
          offer subscriptions and memberships, and handle in-person sales with cash registers.
        </li>
        <li class="description">
          <strong>Sport organization:</strong> Designed for sports events. Sell tickets, annual
          subscriptions, memberships, and fan merchandise.
        </li>
      </ul>

      <main-button
        depressed
        text="Understand"
        class="understand-button"
        @click="$emit('closeModal')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'organization-type-description-modal',
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 24.3125rem;
  padding: 2rem;
  border-radius: 4px;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}

.description {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0;
}

.understand-button {
  width: 100%;
  margin: 2rem 0 0.5rem 0;
}

.v-input__icon {
  margin-right: 0.75rem;
}

.modal-title-exit-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
</style>
